import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import { Checkbox } from "@blueprintjs/core";
import Button from "../base-components/button";
import { eventRatingTypes, sortTqrReasonOptionsKeys } from "./TranscriptQualityRating";
import {strToTitle} from "shared/utils/text";

export default class EventQualityReason extends Component {
  constructor(props) {
    super(props);

    const { editReasonOptions, previousEventQualityReasons } = props;

    this.editReasonOptionsSortedKeys = sortTqrReasonOptionsKeys(editReasonOptions);

    let previousEventQualityReasonsExist =
      previousEventQualityReasons.length > 0;

    let previousEditValues = {};
    if (previousEventQualityReasonsExist) {
      previousEventQualityReasons.forEach(
        reason => (previousEditValues[reason] = true)
      );
    }

    this.state = {
      currentRatingType: previousEventQualityReasonsExist
        ? eventRatingTypes.EDIT
        : eventRatingTypes.PASS,
      editValues: previousEditValues,
      redactValues: {},
      isEditPopupDisplayed: false,
      isRedactPopupDisplayed: false,
    };
  }

  componentDidMount() {
    const { propagateQualityReasonCallback } = this.props;
    propagateQualityReasonCallback(this.composeDataForCallback());
  }

  componentDidUpdate() {
    const { propagateQualityReasonCallback } = this.props;
    propagateQualityReasonCallback(this.composeDataForCallback());
  }

  composeDataForCallback = () => {
    const { eventId, editReasonOptions, redactReasonOptions } = this.props;
    const { currentRatingType, editValues, redactValues } = this.state;

    const data = {
      eventId: eventId,
      ratingType: currentRatingType,
    };

    if (currentRatingType === eventRatingTypes.EDIT) {
      data.ratingReasonOptionIds = Object.values(editReasonOptions).filter(
        editReasonOption => {
          return !!editValues[editReasonOption.id];
        }
      ).map(editReasonOption => editReasonOption.id);
    } else if (currentRatingType === eventRatingTypes.REDACT) {
      data.ratingReasonOptionIds = Object.values(redactReasonOptions).filter(
        redactReasonId => {
          return !!redactValues[redactReasonId];
        }
      );
    } else if (currentRatingType === eventRatingTypes.PASS) {
      data.ratingReasonOptionIds = null;
    } else {
      // prettier-ignore
      throw new Error(
        `Unrecognized EventQualityReason.currentRatingType of '${currentRatingType}'.\n`
        `Expected one of '${Object.keys(eventRatingTypes).join("', '")}'.`
      );
    }

    return data;
  };

  renderRatingTypeButtons = () => {
    const {
      currentRatingType,
      isEditPopupDisplayed,
      isRedactPopupDisplayed,
    } = this.state;

    const {
      previousEventQualityReasons,
      updateHighlightPreviousPasses,
      addEventsChangedFromPassCount,
    } = this.props;

    return Object.keys(eventRatingTypes).map(ratingType => {
      const rating = ratingType.toLowerCase();
      return (
        <Button
          key={ratingType}
          //className="transcript-button"
          //className="transcriptQualityRating-edit-button-active"
          className={
            ratingType === currentRatingType
              ? `transcriptQualityRating-${rating}-button-active ${rating}`
              : `transcript-button ${rating}`
          }
          onClick={() => {
            if (previousEventQualityReasons.length === 0) {
              if (
                this.state.currentRatingType === eventRatingTypes.PASS &&
                ratingType !== eventRatingTypes.PASS
              ) {
                updateHighlightPreviousPasses(true);
                addEventsChangedFromPassCount(1);
              } else if (
                this.state.currentRatingType !== eventRatingTypes.PASS &&
                ratingType === eventRatingTypes.PASS
              ) {
                addEventsChangedFromPassCount(-1);
              }
            }

            this.setState({
              currentRatingType: ratingType,
              isEditPopupDisplayed:
                ratingType === eventRatingTypes.EDIT && !isEditPopupDisplayed,
              isRedactPopupDisplayed:
                ratingType === eventRatingTypes.REDACT &&
                !isRedactPopupDisplayed,
            });
          }}
          text={strToTitle(ratingType)}
        />
      );
    });
  };

  renderEditPopup = () => {
    const { editReasonOptions } = this.props;
    const { editValues } = this.state;
    const that = this;

    return (
      <div className="pt-1 pb-1">
        {this.editReasonOptionsSortedKeys.map(function(editReasonLabel) {
          const editReasonId = editReasonOptions[editReasonLabel].id;

          return (
            <Checkbox
              key={editReasonId}
              label={editReasonLabel}
              checked={!!editValues[editReasonId]}
              onChange={() => {
                that.setState(prevState => ({
                  editValues: {
                    ...prevState.editValues,
                    [editReasonId]: !prevState.editValues[editReasonId],
                  },
                }));
              }}
            />
          );
        })}
        <Button className="save-edit" onClick={this.closeEditPopup}>Save</Button>
      </div>
    );
  };

  closeEditPopup = () => {
    this.setState({
      isEditPopupDisplayed: false,
    });
  };

  renderRedactPopup = () => {
    const { redactReasonOptions } = this.props;
    const { redactValues } = this.state;
    const that = this;

    return (
      <div className="pt-1 pb-1">
        {Object.keys(redactReasonOptions).map(function(redactReasonLabel) {
          const redactReasonLabelId = redactReasonOptions[redactReasonLabel];

          return (
            <Checkbox
              key={redactReasonLabelId}
              label={redactReasonLabel}
              checked={!!redactValues[redactReasonLabelId]}
              onChange={() => {
                that.setState(prevState => ({
                  redactValues: {
                    ...prevState.redactValues,
                    [redactReasonLabelId]: !prevState.redactValues[
                      redactReasonLabelId
                    ],
                  },
                }));
              }}
            />
          );
        })}
        <Button className="save-redact" onClick={this.closeRedactPopup}>Save</Button>
      </div>
    );
  };

  closeRedactPopup = () => {
    this.setState({
      isRedactPopupDisplayed: false,
    });
  };

  render() {
    const { eventId } = this.props;
    const { isEditPopupDisplayed, isRedactPopupDisplayed } = this.state;

    return (
      <div className="pt-3">
        <Row>
          <Col xs={12}>
            <span>Event Id: {eventId}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {this.renderRatingTypeButtons()}
            {isEditPopupDisplayed && this.renderEditPopup()}
            {isRedactPopupDisplayed && this.renderRedactPopup()}
          </Col>
        </Row>
      </div>
    );
  }
}
